import request from "@/utils/request";

export function getUserTronInfo() {
  return request({ url: `/user/tron/address/info`, method: "post" });
}
